// extracted by mini-css-extract-plugin
module.exports = {"textLaptop":"Error.page_textLaptop__2Sf-c","block":"Error.page_block__1g5WH"};